import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n';
import { TechDiagram } from '../components/TechDiagram';

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div
      data-testid="not-found-page"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 pt-16 text-center"
    >
      <TechDiagram
        variant="gear"
        className="pointer-events-none absolute -bottom-40 -right-40 aspect-square w-[480px] opacity-25"
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10"
      >
        <p className="font-mono text-7xl font-bold text-silver sm:text-8xl" data-testid="not-found-code">
          {t.notFound.code}
        </p>
        <h1 className="mt-6 text-2xl font-semibold tracking-tight text-steel-bright">
          {t.notFound.title}
        </h1>
        <p className="mt-3 text-sm text-steel">{t.notFound.msg}</p>
        <Link
          to="/"
          data-testid="not-found-back-link"
          className="mt-8 inline-block rounded-sm bg-silver px-6 py-3 text-sm font-medium text-graphite transition-colors duration-200 hover:bg-silver-glow"
        >
          {t.notFound.back}
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
